import { applyMiddleware, createStore, Store } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'
import { ApplicationState, createRootReducer } from './store'

export default function configureStore(initialState?: ApplicationState): Store<ApplicationState> {
	const composeEnhancers = composeWithDevTools({})

	const store = createStore(
		createRootReducer() as any, // to work around what I'm fairly certain is a bug with combineReducers
		initialState,
		composeEnhancers(applyMiddleware(thunkMiddleware))
	)

	return store
}
